import {Component, Inject, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DynamicFormService} from "../../../../../../shared/components/dynamic-forms-components/dynamic-form.service";
import {FormGroup, Validators} from "@angular/forms";
import {FieldConfig, FieldType} from "../../../../../../shared/components/dynamic-forms-components/field.interface";
import {StoreItemActions} from "../../../../../../store/entities/store-item/store-item.actions";
import {StoreItemEntity} from "../../../../../../store/entities/store-item/store-item.model";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../../../store";
import {ASSIGN_PERSON_TO_WAREHOUSE} from "../../../../../../store/entities/warehouse-management/warehouse-assignee/warehouse-assignee.graphql";
import {GET_ALL_MSD_WAREHOUSE} from "../../../../../../store/entities/warehouse-management/warehouse/warehouse.graphql";
import {selectStoreItems} from "../../../../../../store/entities/store-item/store-item.selectors";
import {map} from "rxjs";

@Component({
  selector: 'app-warehouse-assign-person',
  templateUrl: './warehouse-assign-person.component.html',
  styleUrl: './warehouse-assign-person.component.scss'
})
export class WarehouseAssignPersonComponent implements OnInit {
  private dialogRef: MatDialogRef<WarehouseAssignPersonComponent> = inject(MatDialogRef<WarehouseAssignPersonComponent>);
  private dynamicFormService: DynamicFormService = inject(DynamicFormService);

  title = "Assign Person";
  form: FormGroup;
  fields: FieldConfig[];

  userUniqueId: string;

  constructor(
      private store: Store<AppState>,
      @Inject(MAT_DIALOG_DATA) public data: { userUniqueId: string }
  ) {
    this.userUniqueId = data?.userUniqueId;
    this.fields = this.formFields();
  }

  ngOnInit() {
    // Load warehouses
    this.store.dispatch(StoreItemActions.getStoreItems({
      entity: StoreItemEntity.warehouse,
      filtering: { pageNumber: 1 },
      query: GET_ALL_MSD_WAREHOUSE
    }));

    // Create the form with only warehouse field
    this.form = this.dynamicFormService.createControl(this.fields, {});
  }

  submitForm(formValue: any) {
    const input = {
      ...formValue,
      userList: [this.userUniqueId]
    };

    this.store.dispatch(StoreItemActions.createUpdateStoreItem({
      entity: StoreItemEntity.warehouseAssignee,
      input,
      mutation: ASSIGN_PERSON_TO_WAREHOUSE,
      isInput: true
    }));
  }

  formFields(): FieldConfig[] {
    return [
      {
        type: FieldType.select,
        label: 'Warehouse',
        key: 'warehouseUniqueId',
        options: this.store.select(selectStoreItems(StoreItemEntity.warehouse)).pipe(
            map(items => items?.map(warehouse => ({
              ...warehouse,
              label: warehouse?.warehouseName,
              value: warehouse?.uniqueId
            })))
        ),
        validations: [
          {
            message: 'Field is required',
            validator: Validators.required,
            name: 'required'
          }
        ],
        rowClass: 'col-span-12'
      },
      {
        type: FieldType.button,
        label: 'Save',
        rowClass: 'col-span-12'
      }
    ];
  }

  closeModal() {
    this.dialogRef.close();
  }
}
